import type { SqlDriver, Statement } from './driver';

/**
 * Empties this device's database (every table, the device identity and
 * settings included), keeping the schema. The next start is a first start:
 * a new identity and onboarding. Used after deleting an account.
 */
export async function eraseLocalData(db: SqlDriver): Promise<void> {
  const tables = await db.all<{ name: string }>("SELECT name FROM sqlite_master WHERE type = 'table' AND name NOT LIKE 'sqlite_%'");
  const statements: Statement[] = [{ sql: 'PRAGMA defer_foreign_keys = ON' }, ...tables.map((t) => ({ sql: `DELETE FROM "${t.name}"` }))];
  await db.batch(statements);
}
